import { NotificationWithCustomFields } from './notifications.type';

export const api = {
  getUnreadTerminationRequestNotification: async ({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    taskId,
  }: {
    taskId: string;
  }): Promise<NotificationWithCustomFields | undefined> => {
    return undefined;
  },
  getNotificationsPaginated: async ({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    page,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    limit,
  }: {
    page: number;
    limit: number;
  }): Promise<GenericTypes.Paginated<NotificationWithCustomFields>> => {
    return {
      results: [],
      count: 0,
      next: null,
      previous: null,
    };
  },
  getUnreadCount: async (): Promise<number> => {
    return 0;
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getUnread: async (limit: number): Promise<NotificationWithCustomFields[]> => {
    return [];
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  markOneAsRead: async ({ id }: { id: string }): Promise<void> => {
    // noop — notifications service is disabled
  },
};
